.root {
  display: flex;
  flex-direction: column;
}

.emptyState {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 32px;
  padding-bottom: 32px;
  color: var(--tuna-palette-text-secondary);
}

.emptyIcon {
  margin-bottom: 8px;
  opacity: 0.5;
}

.emptyHint {
  margin-top: 4px;
}

.searchField {
  margin-bottom: 8px;
  margin-left: 8px;
  margin-right: 8px;
}

.searchIcon {
  opacity: 0.5;
}
